module.exports = __webpack_public_path__ + "img/TeamComic_053.bc5014a6.png";